<!--
  Header. En escritorio: logo | granja + acceso temporal | acciones, usuario y cerrar sesion.
  En telefonos y tablets (menos de 992px) se reorganiza en filas con CSS grid
  (header.component.scss, bloque "Compacto"); cada elemento lleva una clase
  "header-slot-*" que indica su lugar:
    fila 1: [menu + titulo de seccion] .... [ayuda] [notificaciones] [opciones] [cerrar sesion]
    fila 2: [selector de granja]
    fila 3: [acceso temporal al cliente]
-->
<div class="position-relative">
  <nav
    class="navbar topnavbar bg-light"
    role="navigation"
    style="box-shadow: 0px 0 18px rgba(55, 66, 59, 0.08)"
  >
    <ul class="navbar-header only-desktop m-0" style="width: 60px">
      <a class="navbar-brand m-0">
        <div class="brand-logo brand-icon center">
          <i
            class="fa"
            [ngStyle]="{
              '-webkit-mask-image': 'url(../../../assets/header/nas-logo-small.svg)'
            }"
          ></i>
        </div>

        <div class="brand-logo-collapsed brand-icon center">
          <i
            class="fa"
            [ngStyle]="{
              '-webkit-mask-image': 'url(../../../assets/header/nas-logo-small.svg)'
            }"
          ></i>
        </div>
      </a>
    </ul>

    <!-- Izquierda: granja y, debajo, el acceso temporal al cliente -->
    <ul class="navbar-nav flex-column margin-select-navbar">
      <li
        *ngIf="loading_farm && (user.user_type !== -1 || user.user_type === 0)"
        class="nav-item only-desktop d-flex align-items-center ml-4"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">{{ "general.loading" | translate }}...</span>
        </div>
      </li>
      <li
        class="nav-item header-slot-farm d-flex align-items-center justify-content-center flex-column"
        *ngIf="user.user_type === 1 || user.user_type === 2 || storageService.localValue.mode === 1"
      >
        <ng-container *ngIf="farms.length > 1">
          <select
            [(ngModel)]="storageService.localValue.farm_id"
            class="form-control"
            (change)="setFarm($event.target.value)"
          >
            <option *ngFor="let item of farms" [value]="item.id">
              {{ item.name }}
            </option>
          </select>
        </ng-container>
        <!-- Compacto: con una sola granja se muestra su nombre (en escritorio no se muestra nada) -->
        <div class="farm-name only-compact" *ngIf="farms.length === 1">{{ farms[0].name }}</div>
      </li>
      <li
        *ngIf="loading_farm && !storageService.isAdmin()"
        class="nav-item header-slot-farm only-compact d-flex align-items-center"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">{{ "general.loading" | translate }}...</span>
        </div>
        <small class="text-muted">{{ "header.loading-farms" | translate }}</small>
      </li>
      <!-- Acceso temporal: cliente seleccionado por el admin -->
      <li
        class="nav-item header-slot-client d-flex align-items-center"
        *ngIf="storageService.localValue.client"
      >
        <div class="custom-control custom-switch">
          <input
            [(ngModel)]="mode"
            type="checkbox"
            class="custom-control-input"
            id="temporaryAccessSwitch"
            (change)="changeMode()"
          />
          <label class="custom-control-label c-pointer" for="temporaryAccessSwitch">
            {{ "header.temporary-access" | translate }}: {{ temporaryAccessName() }}
          </label>
        </div>
      </li>
    </ul>

    <ul
      class="navbar-nav flex-row align-items-center font-weight-bold justify-content-around mr-md-4 menu-navbar"
    >
      <!-- Compacto: boton del menu flotante + titulo de la seccion actual -->
      <li class="nav-item header-slot-menu only-compact">
        <a
          class="nav-link sidebar-toggle"
          [attr.aria-label]="'header.open-menu' | translate"
          [attr.aria-expanded]="settings.getLayoutSetting('asideMobileOpen')"
          (click)="toggleMobileMenu()"
        >
          <i class="fa fa-bars" aria-hidden="true"></i>
        </a>
        <span class="section-title" *ngIf="sectionTitle">{{ sectionTitle | translate }}</span>
      </li>
      <li
        class="nav-item header-slot-help dropdown dropdown-list"
        [ngClass]="{
          'd-none': storageService.isAdmin() || HelpService.currentHelp.length === 0
        }"
        dropdown
      >
        <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle>
          <em class="fa fa-info-circle"></em>
        </a>
        <div
          *dropdownMenu
          class="thead-bg dropdown-menu dropdown-menu-right animate__animated animate__fadeIn"
        >
          <div class="dropdown-item">
            <div class="list-group">
              <div
                class="list-group-item list-group-item-action"
                *ngFor="let item of HelpService.currentHelp || []"
              >
                <div class="media" (click)="runHelp(item.content)">
                  <div class="align-self-start mr-2">
                    <em class="fa-2x text-success" [class]="item.icon"></em>
                  </div>
                  <div class="media-body">
                    <p class="m-0">{{ item.label | translate }}</p>
                    <p class="m-0 text-muted text-sm">
                      {{ "topbar.steps" | translate }} {{ item.content.length }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- Notifications Module -->
      <!-- display="dynamic": dentro de .navbar ng-bootstrap usa "static" y, con el
           container "body" global (AppModule), el menu quedaba sin posicionar -->
      <li
        class="nav-item header-slot-bell center dropdown dropdown-list d-inline-block"
        ngbDropdown
        display="dynamic"
        placement="bottom-right"
      >
        <a
          class="nav-link dropdown-toggle dropdown-toggle-nocaret"
          id="dropNotification"
          ngbDropdownToggle
          (click)="refreshNotificationsOnOpen()"
        >
          <i class="fa fa-bell" aria-hidden="true"></i>
          <span class="badge badge-danger">{{ countNotifications }}</span>
        </a>
        <div
          aria-labelledby="dropNotification"
          class="dropdown-menu dropdown-menu-right animate__animated animate__fadeIn content-notification"
          ngbDropdownMenu
        >
          <div class="d-flex justify-content-between p-3 bg-primary">
            <div class="d-flex justify-content-between align-items-center flex-wrap gap-6">
              <button
                class="btn btn-secondary"
                *ngIf="view_farm"
                style="padding: 7px 5px"
                (click)="view_farm = false; farm_selected = null; unReadPerFarm()"
              >
                <em class="fa fa-angle-left fa-2x"></em>
              </button>
              <div class="d-flex flex-column">
                <div
                  class="d-flex flex-wrap gap-6 align-items-center"
                  [routerLink]="['/client-notifications']"
                  routerLinkActive="active"
                >
                  {{ "sidebar.notifications" | translate }}
                  <p class="m-0">( {{ countNotifications }} )</p>
                  <i class="fa fa-bell" aria-hidden="true"></i>
                </div>
                <p class="m-0" *ngIf="view_farm && farm_selected">
                  {{ "general.farm" | translate }}: {{ farm_selected.farm_name }}
                </p>
              </div>
            </div>

            <i
              *ngIf="farm_selected && view_farm"
              class="fas fa-external-link-square-alt c-pointer"
              (click)="redirectNotification('farm')"
            ></i>
          </div>

          <ng-container *ngIf="view_farm">
            <div
              class="list-group"
              style="max-height: 50vh; overflow: auto; cursor: default"
              id="notifications"
            >
              <div class="list-group-item text-center" *ngIf="loading_notifications">
                <app-spinner [smallLoader]="true" [spinnerColor]="'text-primary'"></app-spinner>
              </div>

              <ng-container *ngIf="!loading_notifications">
                <div
                  class="list-group-item list-group-item-action d-flex gap-6 justify-content-between"
                  *ngFor="let item of notifications"
                >
                  <div class="media align-items-center">
                    <div *ngIf="item.kind !== 1">
                      <em class="fa fa-exclamation-triangle text-warning"></em>
                    </div>
                    <div class="align-self-start mr-2">
                      <em class="fab fa-bell fa-2x text-success"></em>
                    </div>
                    <div class="media-body">
                      <p class="m-0">{{ item.title }}</p>
                      <small>{{ item.created_at | date : "medium" }}</small>
                    </div>
                  </div>
                  <div class="d-flex gap-6 align-items-center">
                    <i
                      class="fas fa-external-link-square-alt c-pointer text-primary"
                      (click)="redirectNotification('general', item)"
                    ></i>
                    <i
                      class="fas fa-eye c-pointer text-primary"
                      [ngClass]="{ 'd-none': item.read_time }"
                      (click)="markAsSeen(item.id)"
                    ></i>
                  </div>
                </div>
              </ng-container>

              <div class="bg-primary text-center p-3 c-pointer" (click)="markAsSeenAll(item)">
                <p class="m-0">{{ "header.mark-all-as-seen" | translate }}</p>
              </div>
            </div>
          </ng-container>

          <div
            class="list-group"
            style="max-height: 50vh; overflow: auto; cursor: default"
            id="notifications"
          >
            <div
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center gap-6 c-pointer"
              *ngIf="!view_farm"
              (click)="view_farm = true; farm_selected = null; getSystemNotification()"
            >
              <h4 class="m-0">{{ "header.system-notifications" | translate }}</h4>
              <span class="badge badge-primary" style="font-size: 15px">
                {{ system_notification_count }}</span
              >
            </div>
          </div>

          <ng-container *ngIf="!view_farm">
            <div
              class="list-group"
              style="max-height: 50vh; overflow: auto; cursor: default"
              id="notifications"
            >
              <div class="list-group-item text-center" *ngIf="loading_farm_notifications">
                <app-spinner [smallLoader]="true" [spinnerColor]="'text-primary'"></app-spinner>
              </div>

              <ng-container *ngIf="!loading_farm_notifications">
                <div
                  class="list-group-item list-group-item-action d-flex justify-content-between align-items-center gap-6 c-pointer"
                  *ngFor="let item of farm_notifications"
                  (click)="selectNotificationsFarm(item)"
                >
                  <h4 class="m-0">{{ item.farm_name }}</h4>
                  <span class="badge badge-primary" style="font-size: 12px"> {{ item.count }}</span>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </li>

      <!-- Opciones: abre el panel "Mas opciones" (offsidebar) -->
      <li class="nav-item header-slot-settings center d-flex">
        <a
          class="nav-link"
          [attr.aria-label]="'header.more-options' | translate"
          [title]="'header.more-options' | translate"
          (click)="toggleOffsidebar($event)"
        >
          <i class="fa fa-th" aria-hidden="true"></i>
        </a>
      </li>

      <li class="nav-item header-divider only-desktop" aria-hidden="true"></li>

      <!-- Usuario en sesion -->
      <li
        class="nav-item header-user only-desktop d-flex align-items-center"
        [class.c-pointer]="canEditProfile()"
        (click)="openProfile(profile)"
      >
        <img
          *ngIf="userLogo()"
          [src]="userLogo()"
          class="header-user-avatar rounded-circle"
          alt="user_logo"
          onerror="this.onerror=null;this.src='assets/img/dummy.png';"
        />
        <div class="header-user-info">
          <span class="header-user-name">{{ userDisplayName() }}</span>
          <small class="header-user-role">{{ userRoleKey() | translate }}</small>
        </div>
      </li>

      <!-- Cerrar sesion: pide confirmacion antes de salir -->
      <li class="nav-item header-slot-logout center d-flex">
        <a
          class="nav-link"
          [attr.aria-label]="'sidebar.logout' | translate"
          [title]="'sidebar.logout' | translate"
          [ngbPopover]="logoutPopover"
          #popLogout="ngbPopover"
          triggers="manual"
          placement="bottom-right"
          container="body"
          popoverClass="principal-tooltip"
          [autoClose]="'outside'"
          (click)="popLogout.toggle()"
        >
          <i
            class="fa header-logout-icon"
            aria-hidden="true"
            [ngStyle]="{ '-webkit-mask-image': 'url(../../../assets/menu-icons/logout.svg)' }"
          ></i>
        </a>

        <!-- Confirmacion para cerrar sesion -->
        <ng-template #logoutPopover>
          <div class="p-3" style="min-width: 230px">
            <div class="d-flex align-items-center justify-content-between gap-10">
              <h6 class="m-0 font-weight-bold">
                {{ "header.logout-confirm.title" | translate }}
              </h6>
              <i
                class="fa header-logout-icon header-logout-icon-sm"
                aria-hidden="true"
                [ngStyle]="{ '-webkit-mask-image': 'url(../../../assets/menu-icons/logout.svg)' }"
              ></i>
            </div>
            <p class="mt-2 mb-3 small text-center">
              {{ "header.logout-confirm.message" | translate }}
            </p>
            <div class="d-flex flex-column gap-6">
              <button type="button" class="btn btn-danger btn-sm" (click)="popLogout.close(); logout()">
                {{ "sidebar.logout" | translate }}
              </button>
              <button type="button" class="btn btn-link btn-sm text-muted" (click)="popLogout.close()">
                {{ "general.cancel" | translate }}
              </button>
            </div>
          </div>
        </ng-template>
      </li>
    </ul>
  </nav>
  <div class="pop-notifications">
    <div
      class="content mb-3 animated animate__fadeInDown"
      *ngFor="let item of pop_notifications; let i = index"
    >
      <div class="header" [style.border-bottom]="!item.collapsed ? '1px solid #bab6b6' : ''">
        <div class="title d-flex" style="gap: 10px">
          <div class="d-flex flex-column">
            <p
              class="m-0 default-link"
              (click)="redirectNotification('pop', item)"
              [ngClass]="{
                'title-link':
                  notification &&
                  notification.data.topic !== 'dev_apks' &&
                  notification.data.topic !== 'dev_systems'
              }"
            >
              {{ item.notification.title }}
            </p>
            <small *ngIf="item.data.extra">{{
              item.data.date | date : "MMM d, y, h:mm:ss a"
            }}</small>
          </div>
        </div>

        <div *ngIf="item.data">
          <div style="font-size: 18px" class="d-flex gap-10 p-2">
            <!--   <em
              class="fas fa-external-link-square-alt c-pointer"

            ></em> -->
            <em
              class="fas fa-eye c-pointer text-primary"
              [ngClass]="{ 'd-none': item.read_time }"
              (click)="
                markAsSeen(
                  item && item.data && item.data.topic === 'dev_apks' ? null : item.data.id
                );
                closeNotification(i)
              "
            ></em>
            <!-- <em
              class="far fa-trash-alt text-danger c-pointer"
              (click)="deleteNotification(item, i)"
            ></em> -->
            <em
              class="fa c-pointer"
              (click)="item.collapsed = !item.collapsed"
              [class]="item.collapsed ? 'fa-angle-down' : 'fa-angle-up'"
            ></em>
          </div>
        </div>
      </div>

      <div
        style="position: relative"
        [ngClass]="{
          'collapsed-content-notification': item.collapsed,
          'dropdown-animation': !item.collapsed
        }"
      >
        <div class="body d-flex flex-column">
          <div class="d-flex flex-column" style="font-size: 15px">
            <p class="m-0" style="font-size: 13px">
              {{ item.notification.body }}
            </p>
          </div>

          <div
            class="d-flex gap-20 justify-content-center align-items-center mb-3 flex-wrap"
            *ngIf="item.data && item.data.value && item.data.exceeded"
          >
            <div class="line-height text-center">
              <div class="value-text">
                <p class="text-danger">
                  {{ item.data.value }}
                </p>
                <small class="text-danger">{{ item.data.unit }}</small>
              </div>
              <small>{{ "general.value" | translate }}</small>
            </div>
            <div class="line-height text-center">
              <div class="value-text">
                <p class="text-dark">
                  {{ item.data.exceeded }}
                </p>
                <small class="text-dark">{{ item.data.unit }}</small>
              </div>
              <small>{{ "clients.client-notifications.exceeded-by" | translate }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal perfil (clientes y subclientes) -->
<ng-template #profile>
  <app-profile [user]="profileUser" (submitProfile)="submitUser($event)"></app-profile>
</ng-template>

<div class="alert alert-success" role="alert" *ngIf="needsRefresh">
  <div class="d-flex align-items-center justify-content-between">
    <h4 class="mb-0">{{ "header.new-update-available" | translate }}</h4>

    <button class="btn btn-light" (click)="refresh()">
      {{ "header.update-to" | translate }} {{ newVersion }}<i class="fas fa-redo ml-2" style="font-size: 10px"></i>
    </button>
  </div>
</div>
